import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import useViewport from '../../../common/hooks/useViewport'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { ScrollComponent } from '../../../common/scrollComponent'
import { Footer } from '../../../layout/footer'
import { responsive } from '../../../utils/layout'
import { CreateEditProfile } from '../createEditProfile'
import classes from './index.module.scss'

export const EditProfile = () => {
  const setSearchParams = useSearchParams()[1]
  const { width } = useViewport()

  const handleBack = () => {
    setSearchParams({})
  }

  return (
    <Element className="wh100" style={{ backgroundColor: '#E5E5E5' }}>
      <ScrollComponent>
        <Element
          className={classes.container}
          style={{
            backgroundColor: '#FFFFFF',
            maxWidth:
              width > responsive.PIVOT_WIDTH ? responsive.PIVOT_WIDTH : '100%',
          }}
        >
          <Element
            className={classes.header}
            style={{ borderColor: '#E5E5E8' }}
          >
            <Element
              className={classes.backBtn}
              style={{ color: '#3A414B', borderColor: '#D5D5D5' }}
              onClick={handleBack}
            >
              <Element className="dFlex alignItemsCenter" style={{ gap: 4 }}>
                <Element>
                  <Icon className="icon-arrow-left" style={{ fontSize: 8 }} />
                </Element>
                <Element elementName="span">
                  <Translate value="alertSetting.BACK_TO_ALERT_SETTING" />
                </Element>
              </Element>
            </Element>
          </Element>

          <CreateEditProfile
            createMode={false}
            onCancel={handleBack}
            onSave={handleBack}
          />
        </Element>
        <Footer />
      </ScrollComponent>
    </Element>
  )
}
